import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
import Icon from '../../../icons/components/Icon';
const useStyles = makeStyles()(theme => {
    return {
        button: {
            padding: '2px',
            backgroundColor: theme.palette.action03,
            border: 0,
            outline: 0,
            borderRadius: `50%`,
            '&:hover': {
                backgroundColor: theme.palette.default00 + '04'
            },
            '&.focus-visible': {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.default00}10`
            },
            '&:active': {
                backgroundColor: theme.palette.default00 + '12'
            },
            '&.is-mobile': {
                padding: '10px'
            }
        }
    };
});
const ClickableIcon = ({ accessibilityLabel, className, icon, id, color, onClick, onKeyPress, tabIndex }) => {
    const { classes: styles, cx } = useStyles();
    const isMobile = isMobileBrowser();
    return (React.createElement("button", { "aria-label": accessibilityLabel, className: cx(styles.button, isMobile && 'is-mobile', className), id: id, onClick: onClick, onKeyPress: !onKeyPress ? undefined : onKeyPress, tabIndex: tabIndex, type: 'button' },
        React.createElement(Icon, { size: 24, color: color, src: icon })));
};
export default ClickableIcon;
